import { useTypedQuery } from "hooks";
import { DealerOverviewDashboardQueryKeys } from "modules/DealerOverviewDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useTwilioNumberPriceQuery = (isEnabled: boolean, dealer_id?: number) =>
  useTypedQuery({
    queryKey: DealerOverviewDashboardQueryKeys.twilioNumberPrice(dealer_id),
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { dealer_id: dealer_id }, baseUrl)).data.price,
    enabled: isEnabled && !!dealer_id,
    staleTime: 0
  });
